import { html, unsafeCSS } from 'lit';

import { DERElement } from '~/common/der-element';
import { styles as globalStyles } from '~/ui/scss/main.styles';

export class BodyWrapper extends DERElement {
    static override styles = [unsafeCSS(globalStyles)];

    override render() {
        return html`
            <div class="o-module__body">
                <slot></slot>
            </div>
        `;
    }
}
